import { PasswordInput as MantinePasswordInput, Stack } from '@mantine/core'
import { useForm, zodResolver } from '@mantine/form'
import Form from 'common/Form'
import { PasswordInput } from 'common/inputs/PasswordInput'
import { UpdatePassword } from 'types/auth'
import { updatePasswordSchema } from 'types/schemas'

type Props = {
  onSubmit: (values: UpdatePassword) => void
  onCancel: () => void
}

export function UpdatePasswordForm({ onSubmit, onCancel }: Props) {
  const form = useForm<UpdatePassword>({
    validate: zodResolver(updatePasswordSchema),
  })

  return (
    <Form onSubmit={onSubmit} form={form} onCancel={onCancel} submitText="Zmień hasło">
      <Stack gap="xs">
        <PasswordInput placeholder="Nowe hasło" {...form.getInputProps('password')} />
        <MantinePasswordInput
          label="Powtórz hasło"
          placeholder="Nowe hasło"
          withAsterisk
          {...form.getInputProps('confirmPassword')}
        />
      </Stack>
    </Form>
  )
}
